import { reactive, watch } from 'vue'

const state = reactive({
        mode: 'off',
        message: '',
        description: '',
})

export default function () {
    watch(
        () => state.mode,
        (mode) => {
            if (mode !== 'off') {
                setTimeout(() => {
                    state.mode = 'off'
                }, 5000)
            }
        }
    )

    function notification(type, message, description) {
        if (type === 'success') {
            state.mode = 'success'
        } else if (type === 'error') {
            state.mode = 'error'
        } else {
            state.mode = 'off'
        }

        state.message = message || ''
        state.description = description || 'Thank you for using Hedlyner'
    }

    return {
        state,
        notification
    }
}
